import { render, staticRenderFns } from "./ProductDetailGrid.vue?vue&type=template&id=9b4874d4&scoped=true&"
import script from "./ProductDetailGrid.vue?vue&type=script&lang=js&"
export * from "./ProductDetailGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailGrid.vue?vue&type=style&index=0&id=9b4874d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4874d4",
  null
  
)

export default component.exports